import { useContext } from "react"

import { ChatBotFlowConstructorStore } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/stores/ChatBotFlowConstructorState"

const useChatBotFlowConstructorStore = () => useContext(ChatBotFlowConstructorStore)

export default useChatBotFlowConstructorStore
